document.addEventListener("DOMContentLoaded", function () {
  // Scroll to primary button on "Shop Now" click
  $('.shop_now_button a').on('click', function (e) {
    e.preventDefault();

    setTimeout(function () {
      const offset = window.innerWidth < 767 ? 160 : 140;
      const $target = $('#primar-button');

      if ($target.length) {
        $('html, body').stop(true).animate({
          scrollTop: $target.offset().top - offset
        }, 50);
      }
    }, 200);
  });

  // Initialize Swipers for product thumbnails and main images
  const section_thumb = document.querySelectorAll('.product_thumbnail_slider');
  const thumbnail_loop = document.querySelector('.custom_product_temp')?.getAttribute('data-variants-size');

  for (let i = 1; i <= thumbnail_loop; i++) {

    const thumbsSelector = `.product_meta_swiper-${i}`;
    const mainSelector = `.product_main_slider-${i}`;

    if (
      !document.querySelector(thumbsSelector) ||
      !document.querySelector(mainSelector)
    ) {
      continue;
    }

    const product_thumbs_swiper = new Swiper(`.product_meta_swiper-${i}`, {
      slidesPerView: 4,
      watchSlidesProgress: true,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: `.swiper-button-next-${i}`,
        prevEl: `.swiper-button-prev-${i}`
      },
      breakpoints: {
        300: {
          slidesPerView: 5,
          spaceBetween: 5,
          showSwitchArrows: false
        },
        1150: {
          slidesPerView: 4,
          spaceBetween: 10,
          showSwitchArrows: false
        }
      }
    });

    const main_slider = new Swiper(`.product_main_slider-${i}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: false,
      pagination: {
        el: `.main_pagination-${i}`,
        clickable: true
      },
      thumbs: {
        swiper: product_thumbs_swiper
      },
      on: {
        slideChange: function () {
          const activeIndex = this.activeIndex;
          const sourceHtml = $('.PdpVideoWrapper video').html(); // You may want to ensure this is from the right scope
          const videoUrl = $('.PdpVideoWrapper video source').attr('src'); // This was used in your earlier example
    
          const $sliderContainer = $(this.el).closest('.hero-video');
    
          $sliderContainer.find('.product_media_list').each(function () {
            const slideIndex = parseInt($(this).attr('data-slide'), 10);
    
            const $video = $(this).find('.pswp__custom-video-wrapper video');
            const $source = $video.find('source');
            const $img = $(this).find('.pswp__custom-video-wrapper img');
    
            if (slideIndex === activeIndex) {
              if ($video.length > 0 && $source.length > 0) {
                // Optional: Only update source if necessary
                if ($source.attr('src') !== videoUrl) {
                  $video.html(sourceHtml);
                  $video[0].load();
                }
    
                $video.removeClass('hide');
                $video[0].play();
    
                $video.off('play').on('play', function () {
                  $img && $img.length && $img.addClass('hide');
                });
              }
            } else {
              // Pause and hide other videos
              if ($video.length > 0 && $video[0]) {
                $video[0].pause();
                $video.addClass('hide');
                $img && $img.length && $img.removeClass('hide');
              }
            }
          });
        }
      }
    });

  }

  // Review Swiper (mobile & desktop)
  let all_review_data;

  function initMobileSwiper() {
    const isMobile = window.innerWidth < 768;

    if (document.querySelector('.all_review_data')) {
      // Destroy existing
      if (all_review_data && typeof all_review_data.destroy === 'function') {
        all_review_data.destroy(true, true);
      }

      // Reinitialize based on screen size
      all_review_data = new Swiper('.all_review_data', {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        pagination: {
          el: ".review-swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.review-button-next',
          prevEl: '.review-button-prev'
        }
      });
    }
  }

  // Initialize on full page load
  window.addEventListener("load", initMobileSwiper);
  // Re-initialize on resize
  window.addEventListener("resize", initMobileSwiper);
});


$(function () {
  const $btn          = $('#primar-button');
  const idleText      = $btn.val();                
  const loadingText   = 'Adding...';  

  $btn.on('click', function () {
	// $btn.val(loadingText);        
  });                        
  const observer = new MutationObserver(mutations => {
	mutations.forEach(m => {
	  if (m.attributeName === 'aria-busy' && $btn.attr('aria-busy') === 'false') {
		$btn.val(idleText);      
	  }
	});
  });
  observer.observe($btn[0], { attributes: true });
});

  
 $(document).ready(function(){
  
	$(document).on('click', '.product_color_variants .product_color_options .product_color_values', function () {
	  
	  var active_color = $('.product_color_variants .product_color_options .product_color_values.active_color').attr('data-color');
	  $('.complete-the-set-block .bundle-product').each(function() {
		var $bundle = $(this);
		var $matchedVariant = $bundle.find('.color_variants-set[data-variant-name="' + active_color + '"]');
		if ($matchedVariant.length > 0) {
		  var newImage = $matchedVariant.attr('data-variant-img');
		  $bundle.find('.product-image img').attr('src', newImage);
		  var newvariant_id = $matchedVariant.attr('data-variant-id');
		  $bundle.attr('product-id', newvariant_id);
		  $matchedVariant.addClass('currently_active').siblings().removeClass('currently_active');
		}

		var current_name = $('.modal_popup_content .color_variants-set.currently_active').attr('data-variant-name');
		$('.complete-set-variant .select-color-div .select-color').text(current_name);
		$('.product_set_div .complete-set-variant .select-color-div .select-color').text(current_name);
		
	  });
	});


  $(document).on('click', '.pdp-card-wrapper .pdp-atc-set button.pbm-btn', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const variantId = $btn.attr('data-variant-id');

    if (!variantId) return;

    $btn.prop('disabled', true);
    $btn.addClass('show-loader');

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1
      }
    })
    .done(function () {
      refreshCartDrawerHTML();
      updateCartCount();

    })
    .fail(function (xhr) {
      console.error('Add to cart failed:', xhr.responseText);
    })
    .always(function () {
      setTimeout(function () {
        $btn.prop('disabled', false);
        $btn.removeClass('show-loader');
      }, 1000);
    });
  });


  $(document).on('click', '.pbm-wrap .pdp-atc-set button.pbm-btn', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const variantId = $btn.attr('data-variant-id');

    if (!variantId) return;

    $btn.prop('disabled', true);
    $btn.addClass('show-loader');

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1
      }
    })
    .done(function () {
      refreshCartDrawerHTML();
      updateCartCount();

    })
    .fail(function (xhr) {
      console.error('Add to cart failed:', xhr.responseText);
    })
    .always(function () {
      setTimeout(function () {
        $btn.prop('disabled', false);
        $btn.removeClass('show-loader');
      }, 1000);
    });
  });

	function refreshCartDrawerHTML() {
	  fetch(window.location.href)
		.then(res => res.text())
		.then(html => {
		  const tempDom = document.createElement('div');
		  tempDom.innerHTML = html;
		  const newDrawer = tempDom.querySelector('#mini-cart');
		  /* if (newDrawer) {
			  document.querySelector('#mini-cart').replaceWith(newDrawer);
			  $('#mini-cart').addClass('active_cart_drawer');
		  } */

      const currentDrawer = document.querySelector('#mini-cart');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.classList.add('active_cart_drawer');
      }
      
		})
		.catch(err => console.error('Drawer refresh failed:', err));
    } 
 });

  async function updateCartCount() {
    const countEl = document.getElementById('mini-cart-items-all');
    if (!countEl) return; // Exit early if cart count element is missing
    
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
    
      const { item_count } = await response.json();
    
      // Only update if the count has changed
      if (countEl.textContent != item_count) {
        countEl.textContent = item_count;
        countEl.style.visibility = 'visible';
      }
    } catch (error) {
      console.log('[updateCartCount] Error:', error);
    }
  } 

jQuery(document).ready(function(){

   function getPdpVariantList() {
    var variants = [];

    $('.pdpVariantData li').each(function () {
      var title = $(this).attr('data-title'); // e.g. `76" Queen / Denim`
      var parts = title.split(' / ');

      variants.push({
        size: parts.length > 1 ? parts[0].trim() : null,
        color: parts.length > 1 ? parts[1].trim() : parts[0].trim(),
        vid: $(this).attr('data-vid')
      });
    });

    return variants;
  }

  function updateColorAvailability(selectedSize) {
    var variants = getPdpVariantList();
    if (!variants.length) return;

    // Product has no size option — nothing to filter, leave colors as-is
    var hasSizeOption = variants[0].size !== null;
    if (!hasSizeOption) return;

    var availableColors = [];
    $.each(variants, function (i, v) {
      if (v.size === selectedSize) {
        availableColors.push(v.color);
      }
    });

    var $colorItems = $('.product_color_variants .product_color_options .product_color_values');
    var currentColorStillValid = false;

    $colorItems.each(function () {
      var $item = $(this);
      var colorValue = $item.attr('data-color');
      var isAvailable = availableColors.indexOf(colorValue) !== -1;

      $item.toggleClass('color-unavailable', !isAvailable);

      if (isAvailable && $item.hasClass('active_color')) {
        currentColorStillValid = true;
      }
    });

    // If the currently active color isn't valid for this size,
    // auto-switch to the first available color
    if (!currentColorStillValid && availableColors.length) {
      var $fallback = $colorItems.filter(function () {
        return availableColors.indexOf($(this).attr('data-color')) !== -1;
      }).first();

      if ($fallback.length) {
        $fallback.trigger('click');
      }
    }
  }

  // Block clicks on unavailable colors
  $(document).on('click', '.product_color_variants .product_color_options .product_color_values', function (e) {
    if ($(this).hasClass('color-unavailable')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  });

  // Run whenever a size option is clicked
  $(document).on('click', '.configuration-options.size .config-item.selectvarentcc', function () {
    var selectedSize = $(this).attr('data-config-value');
    updateColorAvailability(selectedSize);
  });

  // Run once on page load for the pre-selected size
  setTimeout(function () {
    var $initialSize = $('.configuration-options.size .config-item.active_configure');

    // Fallback: if nothing is marked active yet, use the first size option
    if (!$initialSize.length) {
      $initialSize = $('.configuration-options.size .config-item.selectvarentcc').first();
    }

    if ($initialSize.length) {
      updateColorAvailability($initialSize.attr('data-config-value'));
    }
  }, 0);

  $(document).on('click', '.selectvarentcc', function () {  // fix Swiper here
    setTimeout(function() {
      if (window.product_thumbs_swiper) {
        window.product_thumbs_swiper.update();
        window.product_thumbs_swiper.navigation.update();
      }
    }, 300);
  });

  var currencySymbol = $('body').attr('data-currency');

  setTimeout(function () {
    var matchedValues = [];

    $('.selectvarentcc').each(function () {
      var $el = $(this);
      var hasActiveClass = false;
      // Check if this element has 'active' class
      $.each(this.classList, function (_, className) {
        if (className.includes('active')) {
          hasActiveClass = true;
          return false;
        }
      });
      // Or check if any child has 'active'
      if (!hasActiveClass) {
        $el.find('*').each(function () {
          $.each(this.classList, function (_, className) {
            if (className.includes('active')) {
              hasActiveClass = true;
              return false;
            }
          });
          if (hasActiveClass) return false;
        });
      }

      if (hasActiveClass) {
        let value = null;
        $.each(this.attributes, function () {
          if (this.name.endsWith('-value')) {
            value = this.value;
            return false;
          }
        });

        if (!value) {
          $.each(this.attributes, function () {
            if (this.name.endsWith('-color')) {
              value = this.value;
              return false;
            }
          });
        }

        if (value) {
          value = value.trim().replace(/["']/g, ''); 
          matchedValues.push(value);
        }
      }
    });

    // Match variant
    var matchedVariantId = null;

    $('option').each(function () {
      let variantValues = [];

      $.each(this.attributes, function () {
        if (this.name.startsWith('variant-') && this.name !== 'variant-id') {
          variantValues.push(this.value.trim().replace(/["']/g, '')); // Sanitize here too if needed
        }
      });
      var allMatch = matchedValues.every(function (val) {
        return variantValues.includes(val);
      });

      if (allMatch) {
        matchedVariantId = $(this).attr('variant-id');
        return false; // Break loop
      }
    });
    // Show/hide media based on matched variant ID
    if (matchedVariantId) {

      $('.modular_variants option').each(function () {
        var PriceId = $(this).attr('variant-id');       
        
        if( PriceId == matchedVariantId ){
          
          var variantPrice = parseFloat($(this).attr('variant-sale-price')) || 0;
          var variantDiscount = parseFloat($(this).attr('variant-discount')) || 0;

          var salePrice = variantPrice - (variantPrice * variantDiscount / 100);
      
          var divideValue = 12; 
          
          var monthlyInstallment = (salePrice / divideValue).toFixed(2);        
          var installmentText = currencySymbol+`${monthlyInstallment}/Month `; 

          $('.metafield-string').text(' '+installmentText);

          
          var check_varaiant_quantity = $(this).attr('variant-qty');
        
            if(check_varaiant_quantity > 0){
              $('.stock_ship_text_product .stock_text .ship_stock_text').text('In Stock');
              $('.stock_ship_text_product .ship_text .instock_estimate_days .estimate_text span').text('Ships in 1-2 days');
              
            }else{
              $('.stock_ship_text_product .stock_text .ship_stock_text').text('Pre-order');
              $('.stock_ship_text_product .ship_text .instock_estimate_days .estimate_text span').text('Ships on July 1st');
            }
        }
      });
    }

  }, 0); 


  const formatMoney = (amount) => {
    // Ensure we always keep two decimal places
    const fixedAmount = Number(amount).toFixed(2);
    const parts = fixedAmount.split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Add comma as thousand separator
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return '$' + formattedInt + '.' + decimalPart;
  };


  $('.selectvarentcc').on('click', function () {

    setTimeout(function () {
      // $('.desktop_sale_block').addClass('hide_block');
      var matchedValues = [];
      
      $('.selectvarentcc').each(function () {
        var $el = $(this);
        var hasActiveClass = false;
        // Check if this element has 'active' class
        $.each(this.classList, function (_, className) {
          if (className.includes('active')) {
            hasActiveClass = true;
            return false;
          }
        });
        // Or check if any child has 'active'
        if (!hasActiveClass) {
          $el.find('*').each(function () {
            $.each(this.classList, function (_, className) {
              if (className.includes('active')) {
                hasActiveClass = true;
                return false;
              }
            });
            if (hasActiveClass) return false;
          });
        }

        if (hasActiveClass) {
          let value = null;
          // Check for '-value' or '-color' attributes
          $.each(this.attributes, function () {
            if (this.name.endsWith('-value')) {
              value = this.value;
              return false;
            }
          });

          if (!value) {
            $.each(this.attributes, function () {
              if (this.name.endsWith('-color')) {
                value = this.value;
                return false;
              }
            });
          }

          if (value) {
            value = value.trim().replace(/["']/g, ''); // ✅ Remove quotes
            matchedValues.push(value);
          }
        }
      });

      // Match variant
      var matchedVariantId = null;

      $('option').each(function () {
        let variantValues = [];

        $.each(this.attributes, function () {
          if (this.name.startsWith('variant-') && this.name !== 'variant-id') {
            variantValues.push(this.value.trim().replace(/["']/g, '')); // Sanitize here too if needed
          }
        });
        var allMatch = matchedValues.every(function (val) {
          return variantValues.includes(val);
        });

        if (allMatch) {
          matchedVariantId = $(this).attr('variant-id');
          return false; // Break loop
        }
      });

      // Show/hide media based on matched variant ID
      if (matchedVariantId) {
        
        $('.modular_variants option').each(function () {
          var PriceId = $(this).attr('variant-id');

          if( PriceId == matchedVariantId ){

            var variantPrice = parseFloat($(this).attr('variant-sale-price')) || 0;
            var variantDiscount = parseFloat($(this).attr('variant-discount')) || 0;

            var salePrice = variantPrice - (variantPrice * variantDiscount / 100);

            var divideValue = 12; 

            var monthlyInstallment = (salePrice / divideValue).toFixed(2);        
            var installmentText = currencySymbol+`${monthlyInstallment}/Month `; 

            $('.metafield-string').text(' '+installmentText);

          }           
        });
      
        $('.w-commerce-commerceaddtocartform input[name="id"]').val(matchedVariantId);

      }
    
    }, 0); 
  });
})
